import { CSSProperties, ReactNode, useCallback } from 'react';
import Hammer from 'react-hammerjs';

import {
  CarouselContainer,
  CarouselSlide,
  CarouselSlider,
  CarouselSliderContainer,
} from './Carousel.styled';
import { CarouselState } from './CarouselState';

type Props = {
  id?: string;
  state: CarouselState;
  slides: ReactNode[];
  navigation?: ReactNode;
  gutter?: number;
  height: number;
  'data-qa-id': string;
};

export function Carousel({
  id,
  state,
  'data-qa-id': qaId,
  slides,
  gutter = 8,
  navigation,
  height,
}: Props) {
  const {
    currentPage,
    responsiveSlidesPerPage,
    goToPreviousPage,
    goToNextPage,
  } = state;

  const swipeHandler = useCallback(
    ({ direction }: { direction: number }) => {
      if (direction === 2) goToNextPage();
      else if (direction === 4) goToPreviousPage();
    },
    [goToNextPage, goToPreviousPage],
  );

  return (
    <CarouselContainer id={id} data-qa-id={qaId} style={{ height }}>
      <Hammer onSwipe={swipeHandler}>
        <CarouselSliderContainer>
          <CarouselSlider
            data-qa-slide-count={slides.length}
            data-qa-id={`${qaId}-slider`}
            style={
              {
                '--current-page': currentPage,
                '--gutter': `${gutter}px`,
                '--slides-per-page-xs': responsiveSlidesPerPage.xs,
                '--slides-per-page-sm': responsiveSlidesPerPage.sm,
                '--slides-per-page-md': responsiveSlidesPerPage.md,
                '--slides-per-page-lg': responsiveSlidesPerPage.lg,
              } as CSSProperties
            }
          >
            {slides.map((slide, index) => (
              <CarouselSlide
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                data-qa-id={`${qaId}-slide-${index}`}
                style={
                  {
                    '--index': index,
                    '--nth-index-xs': index % responsiveSlidesPerPage.xs,
                    '--nth-index-sm': index % responsiveSlidesPerPage.sm,
                    '--nth-index-md': index % responsiveSlidesPerPage.md,
                    '--nth-index-lg': index % responsiveSlidesPerPage.lg,
                  } as CSSProperties
                }
              >
                {slide}
              </CarouselSlide>
            ))}
          </CarouselSlider>
        </CarouselSliderContainer>
      </Hammer>

      {navigation}
    </CarouselContainer>
  );
}
